import { Grid } from '@mui/material';
import { GridProps } from '@mui/material/Grid/Grid';
import React from 'react';

type GridContainerProps = Pick<
  GridProps,
  'direction' | 'justifyContent' | 'alignItems' | 'children' | 'columns' | 'sx' | 'spacing'
>;

// TODO: Add support for sub-grids. As it stands now, this component is good for page wide layouts. If we
// want to layout content within this we need a sub grid. Since this uses a custom set of columns we'll
// need some intelligence to generate the sub grid.
// Example: Sign In page. The Sign In container is 6 columns wide. To generate this layout we need to use
// this GridContainer with a GridItem. The issue arises from the layout within the container. We have some
// components that are 6 columns wide while others are 4. To support this we'll need a GridItem that
// accepts a `container` property and has smart columns. I say "smart columns" because the max number of
// columns should not exceed the parent.

// But now that I think about it, it may be OK for the sub-grid to exceed the parents. The author will
// need to be aware of this fact and scale their grid item column spans accordingly.
const GridContainer: React.FC<GridContainerProps> = ({
  children,
  direction = 'row',
  justifyContent = 'flex-start',
  alignItems = 'stretch',
  sx,
  spacing = 2,
}) => {
  return (
    <Grid
      container
      direction={direction}
      justifyContent={justifyContent}
      alignItems={alignItems}
      sx={sx}
      columns={{ md: 12, sm: 8, xs: 4 }}
      spacing={spacing}
    >
      {children}
    </Grid>
  );
};

export { GridContainer as default, GridContainer };
export type { GridContainerProps };
